import { render } from "./ExpertView.vue?vue&type=template&id=113ff0dc&scoped=true"
import script from "./ExpertView.vue?vue&type=script&lang=js"
export * from "./ExpertView.vue?vue&type=script&lang=js"

import "./ExpertView.vue?vue&type=style&index=0&id=113ff0dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-113ff0dc"]])

export default __exports__